export default "__VITE_ASSET__DogapDGJ__"